import { ApolloError } from '@apollo/client';

export const getErrorCode = (error?: ApolloError) => {
    return error?.graphQLErrors?.[0]?.extensions?.code;
};
